module.exports = __webpack_public_path__ + "img/title@2x.6c1158d7.png";